export default class WysiwygEditor {

  constructor(container) {
    this.container = container;
  }

  initEditor() {
    let candidates = this.container.getElementsByClassName('wysiwyg');
    this.editorElement = candidates[ 0 ];
    tinyMCE.init({
      target: this.editorElement,
      menubar: false,
      resize: false,
      statusbar: false,
      inline: true,
      toolbar: 'undo redo | bold italic | removeformat',
      plugins: [ 'paste', 'table', 'lists' ],
      paste_as_text: true
    }).then(list => {
      this.editor = list[ 0 ];
      this.prepareEditor();
    });
  }

  prepareEditor() {
    this.editor.focus();
    this.editor.on('keyup', () => {
      this.value = this.editor.getContent();
    });
  }

  removeEditor() {
    tinyMCE.remove(this.editor);
  }
}
